function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function esc(app, value) {
  return app.browser.escapeHTML(String(value !== null && value !== void 0 ? value : ''));
}
function renderPrimitive(app, value) {
  if (value === null) {
    return "<span class=\"explorer-json-null\">null</span>";
  }
  if (typeof value === 'boolean') {
    return "<span class=\"explorer-json-bool\">".concat(value ? 'true' : 'false', "</span>");
  }
  if (typeof value === 'number') {
    return "<span class=\"explorer-json-number\">".concat(esc(app, value), "</span>");
  }
  return "<span class=\"explorer-json-string\">\"".concat(esc(app, value), "\"</span>");
}
function renderJsonTree(app, value) {
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var depth = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var keyHtml = key != null ? "<span class=\"explorer-json-key\">\"".concat(esc(app, key), "\"</span><span class=\"explorer-json-colon\">: </span>") : '';
  if (value === null || _typeof(value) !== 'object') {
    return "<div class=\"explorer-json-line\">".concat(keyHtml).concat(renderPrimitive(app, value), "</div>");
  }
  var isArray = Array.isArray(value);
  var entries = isArray ? value.map(function (item, index) {
    return [String(index), item];
  }) : Object.entries(value);
  var open = isArray ? '[' : '{';
  var close = isArray ? ']' : '}';
  if (!entries.length) {
    return "<div class=\"explorer-json-line\">".concat(keyHtml, "<span class=\"explorer-json-brace\">").concat(open).concat(close, "</span></div>");
  }
  var childId = "json-".concat(Math.random().toString(36).slice(2, 10));
  var children = entries.map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      entryKey = _ref2[0],
      entryValue = _ref2[1];
    return renderJsonTree(app, entryValue, entryKey, depth + 1);
  }).join('');
  return "\n    <div class=\"explorer-json-node".concat(depth === 0 ? ' explorer-json-root' : '', "\" data-json-open=\"true\">\n      <div class=\"explorer-json-line explorer-json-line-toggle\">\n        <button type=\"button\" class=\"explorer-json-toggle\" aria-expanded=\"true\" aria-controls=\"").concat(childId, "\">\n          <i class=\"fas fa-caret-down\" aria-hidden=\"true\"></i>\n        </button>\n        ").concat(keyHtml, "\n        <span class=\"explorer-json-brace\">").concat(open, "</span>\n        <span class=\"explorer-json-meta\">").concat(entries.length, " ").concat(isArray ? 'items' : 'keys', "</span>\n      </div>\n      <div class=\"explorer-json-children\" id=\"").concat(childId, "\">\n        ").concat(children, "\n      </div>\n      <div class=\"explorer-json-line\"><span class=\"explorer-json-brace\">").concat(close, "</span></div>\n    </div>\n  ");
}
module.exports = {
  renderJsonTree: renderJsonTree
};